import React, { useEffect, useState, useCallback } from "react";
import { FormProvider, useForm } from "react-hook-form";
import {
  Outlet,
  useLocation,
  useNavigate,
  useOutletContext,
} from "react-router";
import BoxLayout from "../../../components/Common/BoxLayout/BoxLayout";
import Button from "../../../components/Common/Button/Button";
import { yupResolver } from "@hookform/resolvers/yup";
import Input from "../../../components/Common/Input/Input";
import { createPasscode } from "../../../utils/mainTabs/events/createPasscode";
import {
  getUserByNameActionHandler,
  postCreatePasscodeActionHandler,
  eventGetClassByTagsLiveTrainingActionHandler,
  eventGetClassByTagsVirtualTrainingActionHandler,
} from "../../../store/actions/actionHandlers/eventActionHandler";
import { useDispatch } from "react-redux";
import { validations } from "../../../utils/validations";
import classes from "./CreatePasscode.module.scss";
import Moment from "react-moment";
import { setErrorAction } from "../../../store/actions/actionCreators/errorActionCreator";
import useComponentVisible from "../../../hooks/useComponentVisible";
import { passcodeSchema } from "../../../utils/mainTabs/events/eventSchema";
import { errorTypes } from "../../../utils/errorTypes";
import { useSelector } from "react-redux";
import { FormattedMessage, injectIntl } from "react-intl";
import Loader from "../../../components/Common/Loader/Loader";
import moment from "moment";

const CreatePasscode = ({ intl }) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const location = useLocation();
  const { SUCCESS, FAIL, WARN } = errorTypes;
  const [title, setTitle] = useState("");
  const [instructorList, setInstructorList] = useState([]);
  const [APIData, setAPIData] = useState([]);
  const [filteredResults, setFilteredResults] = useState([]);
  const { tenantName, roleTitle, isTenantProfileNameExist } =
    useOutletContext();
  const dateFormatyyyymmdd = (date) => {
    const today = date;
    const yyyy = today.getFullYear();
    let mm = today.getMonth() + 1;
    let dd = today.getDate();

    if (dd < 10) dd = "0" + dd;
    if (mm < 10) mm = "0" + mm;

    return yyyy + "-" + mm + "-" + dd;
  };

  const eventState = useSelector((state) => state.commonReducer);
  const { myProfile } = eventState;

  const [fromMinDate, setFromMinDate] = useState(
    dateFormatyyyymmdd(new Date()),
  );
  const [toMinDate, setToMinDate] = useState(dateFormatyyyymmdd(new Date()));
  const [fromMaxDate, setFromMaxDate] = useState(null);
  const [toMaxDate, setToMaxDate] = useState(null);
  const [fromDate, setFromDate] = useState(null);
  const [toDate, setToDate] = useState(null);
  const [loader, setLoader] = useState(false);
  const [instructorLoader, setInstructorLoader] = useState(false);
  const [instructorLoginId, setInstructorLoginId] = useState(null);
  const tilesLabel = createPasscode.tiles(navigate, tenantName);
  const createPasscodePath = createPasscode.path(tenantName);
  useEffect(() => {
    if (
      location.pathname === createPasscodePath &&
      roleTitle.includes("VIRTUAL_QUIZ_TEXT") &&
      location.pathname === createPasscodePath &&
      isTenantProfileNameExist.includes("VirtualQuizzing")
    ) {
      navigate(`${createPasscodePath}/virtualQuizEvents`);
    } else if (
      location.pathname === createPasscodePath &&
      roleTitle.includes("LIVE_QUIZ_TEXT") &&
      location.pathname === createPasscodePath &&
      isTenantProfileNameExist.includes("LiveQuizzing")
    ) {
      navigate(`${createPasscodePath}/liveQuizEvents`);
    }
    if (location.pathname === `${createPasscodePath}/virtualQuizEvents`) {
      setTitle(tilesLabel[0].label);
      reset();
      reset(APIData);
      dispatch(eventGetClassByTagsVirtualTrainingActionHandler(setAPIData));
      clearAll();
    } else {
      setTitle(tilesLabel[1].label);
      reset();
      reset(APIData);
      dispatch(eventGetClassByTagsLiveTrainingActionHandler(setAPIData));
      clearAll();
    }
  }, [location, navigate, createPasscodePath, roleTitle]);
  const methods = useForm({
    mode: "onChange",
    resolver: yupResolver(passcodeSchema),
  });
  const {
    handleSubmit,
    formState: { errors },
    reset,
    watch,
    setValue,
  } = methods;
  const dropdownlist = watch(["instructor", "event"]);

  const [startDate, setStartDate] = useState();
  const [endDate, setEndDate] = useState();
  const [isStartDateEqualCurrentDate, setIsStartDateEqualCurrentDate] =
    useState();
  const eventStartDate = (dateTime) => {
    const inputDate = moment(dateTime).utc(); // Set the time to 18:30:00
    const isoStartDate = inputDate;
    setStartDate(dateTime);
    return isoStartDate;
  };
  const eventEndDate = (dateTime) => {
    const inputDate = new Date(dateTime); // Set the time to 18:30:00
    inputDate.setHours(23, 59, 59);
    const isoEndDate = inputDate;
    setEndDate(dateTime);
    return isoEndDate;
  };

  const [eventRef, isComponentVisible, setIsComponentVisible] =
    useComponentVisible();

  const [
    instructorRef,
    isInstructorComponentVisible,
    setIsInstructorComponentVisible,
  ] = useComponentVisible();
  const onSubmit = (data) => {
    let currentLocalTime = moment().format("YYYY-MM-DD");
    setIsStartDateEqualCurrentDate(data.fromDate);
    if (data.fromDate === currentLocalTime) {
      let submitData = {
        EndDateTime: eventEndDate(data.toDate),
        InstructorLoginId: instructorLoginId,
        InstructorName: data.instructor,
        LiveEventAnswerDuration: 30,
        PassCode: data.passcode,
        ShotClassName: data.event,
        StartDateTime: eventStartDate(new Date()),
      };
      dispatch(postCreatePasscodeActionHandler(submitData, setLoader));
    } else {
      let submitData = {
        EndDateTime: eventEndDate(data.toDate),
        InstructorLoginId: instructorLoginId,
        InstructorName: data.instructor,
        LiveEventAnswerDuration: 30,
        PassCode: data.passcode,
        ShotClassName: data.event,
        StartDateTime: eventStartDate(data.fromDate),
      };
      dispatch(postCreatePasscodeActionHandler(submitData, setLoader));
    }
    clearAll();
  };

  const clearAll = () => {
    reset();
    setToMinDate(dateFormatyyyymmdd(new Date()));
    setFromMinDate(dateFormatyyyymmdd(new Date()));
    setToMinDate(dateFormatyyyymmdd(new Date()));
    setFromMinDate(dateFormatyyyymmdd(new Date()));
    setFromMaxDate(null);
    setToMaxDate(null);
    setFromDate(null);
    setToDate(null);
    setValue("fromDate", null);
    setValue("fromTime", null);
    setValue("toDate", null);
    setValue("toTime", null);
    setInstructorLoginId(null);
  };
  const [instructorResults, setInstructorResults] = useState([]);
  const handleGetUserByName = useCallback(
    (e) => {
      setIsInstructorComponentVisible(true);
      let val = e.target.value.trim() !== "" && e.target.value;
      if (val) {
        setInstructorLoader(true);
        dispatch(
          getUserByNameActionHandler(e.target.value, setInstructorList),
        ).then((response) => {
          if (response) {
            setInstructorLoader(false);
          }
        });
        const instructorfilterData = APIData?.filter(
          (item) =>
            item?.fullName
              ?.toLowerCase()
              .indexOf(e.target.value.toLowerCase()) >= 0,
        );
        setInstructorResults(instructorfilterData);
      } else {
        setInstructorLoader(true);
        setInstructorResults(APIData);
      }
    },
    [dispatch],
  );
  // const searchItems = useCallback((searchValue) => {
  //   setSearchInput(searchValue);
  //   if (searchInput !== "") {
  //     const filteredData = APIData.filter((item) => {
  //       return Object.values(item)
  //         .join("")
  //         .toLowerCase()
  //         .includes(searchInput.toLowerCase());
  //     });
  //     console.log(searchValue);
  //     setFilteredResults(filteredData);
  //   }
  // else {
  //     setFilteredResults(APIData);
  //   }
  // });
  const handleEventList = (e) => {
    setIsComponentVisible(true);
    let val = e.target.value.trim() !== "" && e.target.value;
    if (e.target.value.trim() !== "") {
      const filterData = APIData?.filter(
        (item) =>
          item?.EventName?.toLowerCase().indexOf(
            e.target.value.toLowerCase(),
          ) >= 0,
      );
      setFilteredResults(filterData);
    } else {
      setFilteredResults(APIData);
    }
  };

  // const disablePastDate = () => {
  //   // const today = new Date();
  //   // const dd = String(today.getDate()).padStart(2, "0");
  //   // const mm = String(today.getMonth() + 1).padStart(2, "0"); //January is 0!
  //   // const yyyy = today.getFullYear();
  //   // return yyyy + "-" + mm + "-" + dd;
  // };
  const listOnClick = () => {
    setIsComponentVisible(!isComponentVisible);
  };
  const instructorlistOnClick = () => {
    setIsInstructorComponentVisible(!isInstructorComponentVisible);
  };

  const handleFromDate = (e) => {
    setFromDate(e.target.value);
    if (e.target.value) setToMinDate(e.target.value);
  };

  const handleToDate = (e) => {
    setToDate(e.target.value);
    if (e.target.value) setFromMaxDate(e.target.value);
  };
  const [validPasscode, setValidPasscode] = useState(false);
  const handlePattern = useCallback(
    (e) => {
      let val = e.target.value.trim() !== "" && e.target.value;
      if (val) {
        if (/^[a-z0-9]+$/i.test(val)) {
          setValidPasscode(false);
        } else {
          setValidPasscode(true);
        }
      } else {
        setValidPasscode(false);
      }
    },
    [setValidPasscode],
  );

  return (
    <BoxLayout margin={[0, 0, 0, 0]}>
      <FormProvider {...methods}>
        <form onSubmit={handleSubmit(onSubmit)}>
          <div className={classes.createPasscodeMainDiv}>
            <h1 className={classes.createPasscodeMainDiv__heading}>
              Create {title} Event
            </h1>
            <div className={classes.formDiv}>
              <div className={classes.selectInstructor}>
                {/* <Input
                  label={"Select instructor"}
                  name="instructor"
                  placeholder={"Select instructor"}
                  labelColor="light"
                  required
                  tagType="single"
                  fieldValue={"ID"}
                  fieldName={"fullName"}
                  searchTagsList={instructorList}
                  onChange={handleGetUserByName}
                  type="tags"
                /> */}
                <Input
                  label={"Select Instructor"}
                  name="instructor"
                  placeholder={"Select instructor"}
                  labelColor="light"
                  required
                  fieldName={"fullName"}
                  onChange={handleGetUserByName}
                  error={errors?.instructor?.message}
                  // loading={"true"}
                />
                {isInstructorComponentVisible ? (
                  <div>
                    {dropdownlist[0]?.length > 0 && (
                      <ul>
                        {instructorLoader ? (
                          <li className={classes.searLoader}>
                            <Loader width={40} height={40} />
                          </li>
                        ) : instructorList.length === 0 ? (
                          <li style={{ cursor: "auto" }}>No result found.</li>
                        ) : (
                          instructorList?.map((item) => {
                            return (
                              <li
                                key={item.ID}
                                onClick={() => {
                                  setValue("instructor", item.fullName);
                                  setInstructorLoginId(item.ID);
                                  instructorlistOnClick();
                                }}
                              >
                                {item.fullName}
                              </li>
                            );
                          })
                        )}
                      </ul>
                    )}
                  </div>
                ) : (
                  <></>
                )}
              </div>
              <div className={classes.selectInstructor}>
                <Input
                  label={"Select Event"}
                  name="event"
                  placeholder={"Select Event"}
                  labelColor="light"
                  required
                  fieldName={"EventName"}
                  onChange={handleEventList}
                  error={errors?.event?.message}
                />
                {isComponentVisible ? (
                  <div>
                    {dropdownlist[1]?.length > 0 && (
                      <ul>
                        {filteredResults?.map((item) => {
                          return (
                            <li
                              key={item.ID}
                              onClick={() => {
                                setValue("event", item.EventName);
                                listOnClick();
                              }}
                            >
                              {item.EventName}
                            </li>
                          );
                        })}
                        {filteredResults.length === 0 && (
                          <li style={{ cursor: "auto" }}>No result found.</li>
                        )}
                      </ul>
                    )}
                  </div>
                ) : (
                  <></>
                )}
              </div>
              {/* <Input
                label={"Select Event"}
                name="event"
                placeholder={"Group - B"}
                labelColor="light"
                error={errors.Search?.message}
                required
              /> */}
              {/* <div style={{position: "relative"}}> */}
              <div>
                <Input
                  label={<FormattedMessage id="P_START_DATE" />}
                  // name="startDate"
                  name="fromDate"
                  placeholder={intl.formatMessage({
                    id: `P_START_DATE`,
                  })}
                  labelColor="light"
                  error={errors?.startDate?.message}
                  required
                  type={"date"}
                  min={fromMinDate}
                  max={fromMaxDate}
                  onChange={handleFromDate}
                />
                {errors?.fromDate?.message && (
                  <div className={classes.errorMsg}>
                    {errors?.fromDate?.message}
                  </div>
                )}
              </div>
              <div>
                <Input
                  label={<FormattedMessage id="P_END_DATE" />}
                  // name="endDate"
                  name="toDate"
                  placeholder={intl.formatMessage({
                    id: `P_END_DATE`,
                  })}
                  labelColor="light"
                  error={errors?.endDate?.message}
                  required
                  type="date"
                  min={toMinDate}
                  max={toMaxDate}
                  onChange={handleToDate}
                />
                {errors?.toDate?.message && (
                  <div className={classes.errorMsg}>
                    {errors?.toDate?.message}
                  </div>
                )}
              </div>

              <div>
                <Input
                  label={"Enter Passcode"}
                  name="passcode"
                  placeholder={"New Passcode"}
                  labelColor="light"
                  maxLength={15}
                  // error={errors?.passcode?.message}
                  onChange={handlePattern}
                  required
                />
                {errors?.passcode?.message ? (
                  <div className={classes.errorMsg}>
                    {errors?.passcode?.message}
                  </div>
                ) : validPasscode ? (
                  <div className={classes.errorMsg}>
                    Please enter valid format
                  </div>
                ) : (
                  <></>
                )}
              </div>
            </div>
            <div className={classes.quizBtns}>
              <div className={classes.quizBtns_ClearAll} onClick={clearAll}>
                <FormattedMessage id="CLEAR_ALL_TXT" />
              </div>
              <Button
                label="Create Event"
                type="submit"
                disabled={validPasscode}
                small
                dark
                loading={loader}
              />
            </div>
          </div>
          <Outlet />
        </form>
      </FormProvider>
    </BoxLayout>
  );
};

export default injectIntl(CreatePasscode);
